import React from 'react';
import useLocalStorage from 'use-local-storage';


export default function useApiPath() {
  const [isApiProd] = useLocalStorage("isApiProd", true);

  return isApiProd ? process.env.REACT_APP_PROD_HELINLABS_API_URL : process.env.REACT_APP_DEV_HELINLABS_API_URL;
}
